import { useAuth } from '../../contexts/AuthProvider/useAuth';
import { AppRoutes } from '../../routes';
import { isMobileDevice } from '../../commons/utils';
import { useState } from 'react';
import { AppBar, VbDrawer, VbIconButtonAuxSideBar, Main } from './SideBar/components';
import { Box, Toolbar } from '@mui/material';
import { SideBar } from './SideBar';
import { useThemeContext } from '../../theme';
import { Dropdown } from 'react-bootstrap';
import { DropdownItem, DropdownToggle, TitleToogle } from '../../components/VbNavbar';
import { SwitchTheme } from '../../components/SwitchTheme';
import { FaBuilding } from 'react-icons/fa';

export const Principal = () => {
    const auth = useAuth();
    const { themeMode, toggleTheme } = useThemeContext();

    const [expanded, setExpanded] = useState<any>(true);

    const clickExpanded = () => {
        setExpanded(!expanded)
    }

    const clickItemMenu = (to: any) => {
        setExpanded(to === undefined ? true : !isMobileDevice());
    };

    return (
        <Box style={{ display: 'flex' }}>
            <AppBar position="fixed" open={expanded}>
                <Toolbar id='principal-toolbar' variant='dense' style={{ backgroundColor: 'var(--side-bar-color)' }} >
                    <VbIconButtonAuxSideBar onClick={clickExpanded} />
                    <SwitchTheme
                        defaultChecked={themeMode === 'dark'}
                        sx={{ position: `${isMobileDevice() ? 'fixed' : 'relative'}`, left: `${isMobileDevice() ? '3rem' : '0'}` }}
                        onChange={toggleTheme}
                    />

                    {(auth.empresas.length > 1) &&
                        <Dropdown style={{ position: 'fixed', right: 15 }}>
                            <DropdownToggle>
                                <TitleToogle>
                                    <FaBuilding style={{ marginRight: '6px', marginTop: '-4px' }} />
                                    Selecione a Empresa:
                                </TitleToogle>
                                {auth?.usuarioEmpresa?.empresa?.empnome}
                            </DropdownToggle>

                            <Dropdown.Menu>
                                <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                                    {
                                        auth.empresas.map((usuEmp: any, index: any) => (
                                            <DropdownItem key={index} onClick={() => auth.alterUser(usuEmp)}>{usuEmp.empresa.empnome}</DropdownItem>
                                        ))
                                    }
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    }

                </Toolbar>
            </AppBar>

            <VbDrawer open={expanded} variant={isMobileDevice() ? "temporary" : "persistent"} >
                <SideBar clickExpanded={clickExpanded} clickItemMenu={clickItemMenu} />
            </VbDrawer>

            <Main open={expanded}>
                <div style={{ padding: '2px', marginTop: '48px', backgroundColor: 'var(--background-color)', borderTopLeftRadius: '6px' }}>
                    <AppRoutes />
                </div>
            </Main>
        </Box >
    )
}